module.exports = __webpack_public_path__ + "img/sp.1eac5831.png";